<template>
  <ComplianceReviewDecisionForm
    :loading="loading"
    :submitting="isSubmitting"
    :error-message="mutationErrorMessage"
    :initial-decision="initialDecision"
    :initial-note="initialNote"
    data-test-prefix="recruiter-compliance-review"
    :cleared-sub-text="
      $t('The staffing agency will see an in-app notification. No email is sent.')
    "
    :changes-requested-sub-text="
      $t(
        'The staffing agency will receive an email with your note and an in-app notification. Specify the reason in the note field below:',
      )
    "
    :note-label="$t('Add note (sent to the staffing agency) *')"
    @submit="onSubmit"
    @cancel="$emit('cancel')"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useMutation } from '@vue/apollo-composable'
import { graphql } from '@/gql'
import { RecruiterReviewDecision } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import ComplianceReviewDecisionForm, {
  type ReviewDecision,
} from '@/components/compliances/ComplianceReviewModal/ComplianceReviewDecisionForm.vue'

const props = defineProps<{
  recruiterId: string
  loading?: boolean
  initialDecision?: RecruiterReviewDecision | null
  initialNote?: string
}>()
const emit = defineEmits<{ success: []; cancel: [] }>()

const SubmitRecruiterComplianceMutation = graphql(`
  mutation SubmitRecruiterCompliance($input: SubmitComplianceInput!) {
    submitCompliance(input: $input) {
      name
      completed
    }
  }
`)

const {
  mutate: submitCompliance,
  loading: isSubmitting,
  error: mutationError,
} = useMutation(SubmitRecruiterComplianceMutation, {
  clientId: 'publicApi',
  refetchQueries: ['ComplianceCompanyRecruitersTable', 'RecruiterComplianceReviewModal'],
  throws: 'never',
})

const mutationErrorMessage = computed(() => mutationError.value?.graphQLErrors?.[0]?.message ?? '')

async function onSubmit({ decision, note }: { decision: ReviewDecision; note: string | null }) {
  const result = await submitCompliance({
    input: {
      reviewRecruiter: {
        recruiterId: props.recruiterId,
        decision: decision as RecruiterReviewDecision,
        recruiterMessage: note,
      },
    },
  })

  if (result) emit('success')
}
</script>
